/**
 * Interface for Action Plan data structure used across multiple components
 * Provides type safety for permission and status management
 */
export interface ActionPlanData {
  ID?: number;
  Status: string;
  Action: string;
  AssignTo: string | null;
  CreatedBy: string | null;
  AssignedDate?: Date | string | null;
  TargetDate?: Date | string | null;
  RevisedDate?: Date | string | null;
  ActionCompleted: string;
  ActionCompletedBy?: string;
  ActionCompletedOn?: Date | string | null;
  Verification: string;
  VerificationBy?: string;
  VerificationOn?: Date | string | null;
  NewAssignee?: string;
  NewAssigneeId?: string;
  Remarks?: string;
  Module?: string;
  UniqueCode?: string;
  HeaderId?: number;
  
  // Computed permission flags
  IsAssignedToCreator?: boolean;
  IsAssignedToCurrentUser?: boolean;
  IsLoggedInUserCreator?: boolean;
  
  // Additional fields
  MissesCondition?: boolean;
  NoOfMisses?: number;
  UploadDoc?: string;
  DocSrc?: string;
}

/**
 * Constants for Action Plan status and verification values
 * Centralizes magic strings to prevent typos and ensure consistency
 */
export class ActionPlanConstants {
  // Status values
  static readonly STATUS_OPEN = 'Open';
  static readonly STATUS_CLOSED = 'Closed';
  static readonly STATUS_COMPLETE = 'Complete';
  
  // Completion values
  static readonly COMPLETION_YES = 'Yes';
  static readonly COMPLETION_NO = 'No';
  
  // Verification values
  static readonly VERIFICATION_APPROVED = 'Approved';
  static readonly VERIFICATION_DISAPPROVED = 'Disapproved';
  static readonly VERIFICATION_NONE = '';
  
  // Empty/null indicators
  static readonly EMPTY_STRING = '';
}
